export class OnFarmMiModel {
    id?:number;
    farmerID?:string;
    Farmer_ID?:string; 
    land_ID?:number;
    Land_ID?:number;
    landID?:number;
    water_Quality?:string;
    isSubsidyAvail?:string;
    year_subsidy?:string;
    Year_subsidy?:string;
    bal_Area?:number;
    dept_subsidy?:string;
    user_ID: string;
    network_ID: string;
    terminal_ID: string;
    component: string;
    Component: string;
    ComponentID: string;
    delete_OnFarm_record: string;
  }
  